import { createSelector } from 'reselect';

import {
  ASSET_PAGE_ROUTE,
  ASSET_VERSION_PAGE_ROUTE,
  SHARE_ASSET_PAGE_ROUTE,
  SHARE_ASSET_VERSION_PAGE_ROUTE,
} from '../../constants/routes';
import type { AppState } from '../../store/types';
import { denormalizeSearchItem } from '../search/normalizers';

export const getPrevNavigationHistoryItem = (state: AppState) =>
  state.navigationHistory.history.at(-2);

const getSearchItemEntities = (state: AppState) => state.entities;

const getCurrentId = (_state: AppState, currentId: string | undefined) =>
  currentId;

const getOffset = (
  _state: AppState,
  _currentId: string | undefined,
  offset: number,
) => offset;

export const selectSearchItemByOffset = createSelector(
  getPrevNavigationHistoryItem,
  getSearchItemEntities,
  getCurrentId,
  getOffset,
  (navigationHistoryItem, entities, currentId, offset) => {
    if (!navigationHistoryItem || !currentId) {
      return undefined;
    }
    const index = navigationHistoryItem.listIds.indexOf(currentId);
    if (index === -1) {
      return undefined;
    }
    const targetIndex = index + offset;
    if (targetIndex > navigationHistoryItem.listIds.length - 1) {
      return undefined;
    }
    if (targetIndex < 0) {
      return undefined;
    }
    const targetId = navigationHistoryItem.listIds[targetIndex];

    return denormalizeSearchItem(entities, targetId);
  },
);

const getRouter = (state: AppState) => state.router;

const getRouteParams = (state: AppState) => state.routeParams;

const genericRoutes = new Set([
  ASSET_PAGE_ROUTE,
  ASSET_VERSION_PAGE_ROUTE,
  SHARE_ASSET_PAGE_ROUTE,
  SHARE_ASSET_VERSION_PAGE_ROUTE,
]);

export const selectNavigationKey = createSelector(
  getRouter,
  getRouteParams,
  (router, routeParams) => {
    if (genericRoutes.has(routeParams.route)) {
      return routeParams.route;
    }
    return router.location.pathname;
  },
);

const getNavigationHistory = (state: AppState) =>
  state.navigationHistory.history;

export const selectLastNavigationItemSelectedIds = createSelector(
  getNavigationHistory,
  (history) => history.at(-1)?.selectedIds ?? [],
);
